import history from '../../util/history'

const toAccountTitleDetailEditView = async detailId => {
  detailId ? history.push(`/account_titles/details/${detailId}/edit`) : history.push(`/account_titles/details/new`)
  return true
}

export default toAccountTitleDetailEditView
